import type { ComponentProps, ComponentState, SkeletonItem, Slot } from '@fluentui/react-components';

export type GroundingMenuItemSkeletonSlots = {
  root: Slot<'div'>;
  avatar?: Slot<typeof SkeletonItem>;
  primaryText?: Slot<typeof SkeletonItem>;
  secondaryText?: Slot<typeof SkeletonItem>;
};

/**
 * GroundingMenuItemSkeleton Props
 */
export type GroundingMenuItemSkeletonProps = ComponentProps<GroundingMenuItemSkeletonSlots> & {};

/**
 * State used in rendering GroundingMenuItemSkeleton
 */
export type GroundingMenuItemSkeletonState = ComponentState<GroundingMenuItemSkeletonSlots>;
